import React, { useCallback } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { openModal } from '@stores/actions/modal.action';
import { getUser } from '@stores/selectors/user.selector';

const useStyles = makeStyles(() => ({
  groupsList: {
    maxWidth: 260,
    cursor: 'pointer',
  },
}));

const UserGroups = ({ t }: WithTranslation) => {
  const user = useSelector(getUser);
  const classes = useStyles();
  const dispatch = useDispatch();

  const openAllGroups = useCallback(() => {
    dispatch(
      openModal({
        title: t('profile_menu.profile_details.group'),
        type: 'dialog',
        component: (
          <Typography p={1}>
            <ul>
              {user.groups.map((group) => (
                <li key={group.analytic_code}>
                  <Typography>
                    {`${group.analytic_code} ${group.analytic_label}`}
                  </Typography>
                </li>
              ))}
            </ul>
          </Typography>
        ),
      }),
    );
  }, [user.groups]);

  return (
    <Box>
      <Typography>{t('profile_menu.profile_details.group')} :</Typography>
      <Box mt={0.75} onClick={openAllGroups}>
        <ul className={classes.groupsList}>
          {user.groups.slice(0, 10).map((group) => (
            <li key={group.analytic_code}>
              <Typography noWrap>
                {`${group.analytic_code} ${group.analytic_label}`}
              </Typography>
            </li>
          ))}
          {user.groups.length > 10 && (
            <li>
              <Typography>...</Typography>
            </li>
          )}
        </ul>
      </Box>
    </Box>
  );
};

export default withTranslation()(UserGroups);
